module.exports = __webpack_public_path__ + "static/media/tool-03.ab54563c.png";